<template>
  <div>
    <div id="style-2" style="max-height: 600px; overflow: auto">
      <div
        class="class-item mb-2"
        v-for="(item, key) in listClassDuoClone"
        :key="key"
      >
        <div class="class-studying">
          <div class="class-studying-item mt-4">
            <div class="mb-2 d-flex align-center">
              <img
                src="../../../assets/book-open.svg"
                width="16"
                height="16"
                alt=""
                class="mr-2"
              />
              <b style="font-weight: 700">
                <span class="text-uppercase mr-4">{{ item.className }}</span>
                <span style="color: #f2994a" class="text-uppercase">{{
                  item.classLevel
                }}</span>
              </b>
            </div>
            <div class="mb-2 d-flex align-center">
              <img
                src="../../../assets/school.svg"
                width="16"
                height="16"
                alt=""
                class="mr-2"
              />
              <span>
                <span
                  v-if="item.classStatus"
                  :style="
                    'font-weight:600; color:' +
                    (checkStatusClass(item)
                      ? checkStatusClass(item).color
                      : '#000000')
                  "
                >
                  {{ item.classStatus }}
                  <span v-if="item.dateClassStatus && checkStatusClass(item) && checkStatusClass(item).key" style="font-weight: 400;">
                    ({{checkStatusClass(item) ? checkStatusClass(item).key : ''}}: {{item.dateClassStatus}})
                  </span>
                <v-tooltip v-if="item.tooltipText" right>
                  <template v-slot:activator="{ on }">
                    <span
                      v-on="on"
                    >
                      <v-icon size="16" class="mx-2">mdi-information-outline</v-icon>
                    </span>
                  </template>
                  <span v-html="item.tooltipText"></span>
                </v-tooltip>
                </span>
              </span>
            </div>
            <div class="mb-2 d-flex align-center">
              <img
                src="../../../assets/calendar-days.svg"
                width="16"
                height="16"
                class="mr-2"
                alt=""
              />
              <span
                >Ngày vào học:
                {{ item.classJoinDate ? item.classJoinDate : "--" }}</span
              >
            </div>
            <div class="mb-2 d-flex align-center">
              <img
                src="../../../assets/calendar-xmark.svg"
                width="16"
                height="16"
                class="mr-2"
                alt=""
              />
              <span>
                Ngày hết hạn:
                <span class="red--text">{{
                  item.dateClassStatus ? item.dateClassStatus : "--"
                }}</span>
              </span>
            </div>
            <div class="mb-2 d-flex align-center">
              <img
                src="../../../assets/last-join.svg"
                width="16"
                height="16"
                class="mr-2"
                alt=""
              />
              <span>
                Lần cuối vào học:
                <span>{{
                  item.classLastJoinDate ? item.classLastJoinDate : "--"
                }}</span>
              </span>
            </div>
            <div class="d-flex align-center">
              <img
                src="../../../assets/calendar-study.svg"
                width="16"
                height="16"
                class="mr-2"
                alt=""
              />
              <span>
                Lịch học:
                <span>{{
                  item.classSchedule ? item.classSchedule : "--"
                }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="this.listClassDuo && this.listClassDuo.length > 0">
        <div v-if="this.listClassDuoClone.length !== this.listClassDuo.length" class="text-center" :style="{marginTop: this.listClassDuoClone.length === 0 ? '15%' : '2%'}" style="cursor: pointer;" @click="showMoreClass()">
            <div class="more-content">Xem thêm các lớp từng đăng ký</div>
            <img src="../../../assets/more.svg" alt="" srcset="" />
        </div>
        <div v-if="checkShowClass()" class="text-center" style="cursor: pointer;" @click="showOnlyActiveClass()">
            <div class="more-content">Thu gọn</div>
        </div>
    </div>
  </div>
</template>

<script>
import { STATUS_COURSES } from '@/helpers/constant';

export default {
  props: {
    listClassDuo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      STATUS_COURSES,
      listClassDuoClone: [],
      ACTIVE_CLASS_STATUS: 'Đang diễn ra',
    };
  },
  mounted() {
    this.listClassDuoClone = _.cloneDeep(this.listClassDuo);
    this.listClassDuoClone = this.listClassDuoClone.filter((item) => item.classStatus === this.ACTIVE_CLASS_STATUS);
  },
  methods: {
    showMoreClass() {
      console.log('showMoreClass');
      this.listClassDuoClone = _.cloneDeep(this.listClassDuo);
    },
    showOnlyActiveClass() {
      console.log('showOnlyActiveClass');
      this.listClassDuoClone = this.listClassDuoClone.filter((item) => item.classStatus === this.ACTIVE_CLASS_STATUS);
    },
    checkStatusClass(item) {
      const data = STATUS_COURSES.find((e) => e.status === item.classStatus);
      if (data) {
        return data;
      }
      return null;
    },
    checkShowClass() {
      if (this.listClassDuoClone.length === this.listClassDuo.length) {
        if (this.listClassDuo.length === 1) {
          const data = this.listClassDuoClone.find((item) => item.classStatus === this.ACTIVE_CLASS_STATUS);
          if (data) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
  },
  watch: {
    listClassDuo: {
      handler() {
        this.listClassDuoClone = _.cloneDeep(this.listClassDuo);
        this.listClassDuoClone = this.listClassDuoClone.filter((item) => item.classStatus === this.ACTIVE_CLASS_STATUS);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.class-studying-item {
  border: 1px solid #b1a3a3;
  border-radius: 5px;
  padding: 15px;
}
.more-content {
  color: #2ebbce;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 114.286% */
}
</style>
